import { DataType, ValueType } from './types';

export type SelectValueAdapter<Value extends ValueType> = {
  variant: DataType;
  serialize(value: Value): string;
  deserialize(value: string): Value;
};

const StringValueAdapter: SelectValueAdapter<string> = {
  variant: 'string',
  serialize: (value) => value ?? '',
  deserialize: (value) => value,
};

const NumberValueAdapter: SelectValueAdapter<number> = {
  variant: 'number',
  serialize: (value) => value.toString() ?? '',
  deserialize: (value) => Number(value),
};

export const adapterMap = {
  string: StringValueAdapter,
  number: NumberValueAdapter,
} as const;
